/* SFD — site-wide ex/inc VAT switch.
 *
 * Two explicit buttons rather than a sliding knob. A slider tells you which
 * way it is pointing; this tells you which mode you are IN, in words, with
 * the live one filled. On a trade site where the whole point is that the
 * customer trusts the number, that ambiguity is not worth the elegance.
 *
 * State is a cookie so it survives navigation and is readable before first
 * paint; meta-tags.liquid sets the <html> class inline to stop the price
 * flickering from one mode to the other on load.
 *
 * Nothing here touches a price. Every price renders both figures from
 * price.liquid; the only job of this file is to put vat-ex or vat-inc on
 * <html> and let CSS decide which one is the headline.
 */
(function () {
  'use strict';

  var KEY = 'sfd_vat';

  var MARKUP =
    '<span class="sfd-vat" data-sfd-vat role="group"' +
      ' aria-label="Show prices excluding or including VAT">' +
      '<button type="button" data-mode="ex">EX VAT</button>' +
      '<button type="button" data-mode="inc">INC VAT</button>' +
    '</span>';

  function mode() {
    var m = document.cookie.match(/(?:^|;\s*)sfd_vat=(ex|inc)/);
    return m ? m[1] : 'ex';
  }

  function paint(m) {
    var root = document.documentElement;
    root.classList.toggle('vat-inc', m === 'inc');
    root.classList.toggle('vat-ex', m !== 'inc');

    var btns = document.querySelectorAll('[data-sfd-vat] button');
    for (var i = 0; i < btns.length; i += 1) {
      var on = btns[i].getAttribute('data-mode') === m;
      btns[i].classList.toggle('on', on);
      btns[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  function set(m) {
    if (m !== 'ex' && m !== 'inc') return;
    document.cookie = KEY + '=' + m + ';path=/;max-age=31536000;samesite=lax';
    paint(m);
    document.dispatchEvent(new CustomEvent('sfd:vat', { detail: { mode: m } }));
  }

  function mount() {
    /* sfd-header.js parks a host in the utility bar; if it has not run yet,
       or is not present at all, fall back to the header icon row */
    var host = document.querySelector('[data-sfd-vat-host]');
    if (host) {
      if (!host.querySelector('[data-sfd-vat]')) host.insertAdjacentHTML('beforeend', MARKUP);
    } else {
      var rows = document.querySelectorAll('.header__icons--right .header__buttons');
      for (var i = 0; i < rows.length; i += 1) {
        if (!rows[i].querySelector('[data-sfd-vat]')) {
          rows[i].insertAdjacentHTML('afterbegin', MARKUP);
        }
      }
    }
    paint(mode());
  }

  /* Delegated, so the control keeps working after the theme re-renders the
     header — which it does on cart update and on section reload. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sfd-vat] button');
    if (!b) return;
    e.preventDefault();
    set(b.getAttribute('data-mode'));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
  document.addEventListener('shopify:section:load', mount);

  window.SFDVat = { mode: mode, set: set, mount: mount };
})();
